export const Notification = ({ isActive }) => (
  <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.3333 14.375C13.3333 16.2159 11.8409 17.7083 10 17.7083C8.15905 17.7083 6.66667 16.2159 6.66667 14.375M15.4137 7.42414L15.5641 10.4017C15.5785 10.6862 15.6535 10.9643 15.784 11.2174L16.7818 13.1526C16.843 13.2713 16.875 13.4031 16.875 13.5367V13.5367C16.875 13.9997 16.4997 14.375 16.0367 14.375H3.96327C3.50031 14.375 3.125 13.9997 3.125 13.5367V13.5367C3.125 13.4031 3.15696 13.2713 3.21821 13.1526L4.21601 11.2174C4.34654 10.9643 4.42149 10.6862 4.43586 10.4017L4.58626 7.42414C4.7305 4.54901 7.11155 2.29166 10 2.29166C12.8884 2.29166 15.2695 4.54901 15.4137 7.42414Z"
      stroke={isActive ? "#225AEA" : "currentColor"}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default Notification
